/* ============================================
   copperMaison — Carousel Component
   Pure JS, no dependencies
   ============================================ */

class Carousel {
  constructor(element) {
    this.el = element;
    this.track = element.querySelector('.carousel__track');
    this.slides = [...element.querySelectorAll('.carousel__slide')];
    this.prevBtn = element.querySelector('[data-carousel="prev"]');
    this.nextBtn = element.querySelector('[data-carousel="next"]');

    if (!this.track || this.slides.length === 0) return;

    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.dragDelta = 0;

    this.init();
  }

  init() {
    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());

    // Touch / mouse drag
    this.track.addEventListener('mousedown', (e) => this.onDragStart(e));
    this.track.addEventListener('mousemove', (e) => this.onDragMove(e));
    this.track.addEventListener('mouseup', () => this.onDragEnd());
    this.track.addEventListener('mouseleave', () => this.onDragEnd());

    this.track.addEventListener('touchstart', (e) => this.onDragStart(e), { passive: true });
    this.track.addEventListener('touchmove', (e) => this.onDragMove(e), { passive: true });
    this.track.addEventListener('touchend', () => this.onDragEnd());

    // Recalculate on resize
    window.addEventListener('resize', () => this.update());
  }

  get slidesPerView() {
    const width = window.innerWidth;
    if (width <= 480) return 1;
    if (width <= 768) return 2;
    if (width <= 1024) return 3;
    return 4;
  }

  get maxIndex() {
    return Math.max(0, this.slides.length - this.slidesPerView);
  }

  getSlideWidth() {
    if (this.slides.length === 0) return 0;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    return this.slides[0].offsetWidth + gap;
  }

  prev() {
    this.currentIndex = Math.max(0, this.currentIndex - 1);
    this.update();
  }

  next() {
    this.currentIndex = Math.min(this.maxIndex, this.currentIndex + 1);
    this.update();
  }

  update() {
    const offset = this.currentIndex * this.getSlideWidth();
    this.track.style.transform = `translateX(-${offset}px)`;
  }

  onDragStart(e) {
    this.isDragging = true;
    this.startX = (e.touches ? e.touches[0].pageX : e.pageX);
    this.track.style.transition = 'none';
  }

  onDragMove(e) {
    if (!this.isDragging) return;
    const x = e.touches ? e.touches[0].pageX : e.pageX;
    this.dragDelta = x - this.startX;

    const currentOffset = this.currentIndex * this.getSlideWidth();
    this.track.style.transform = `translateX(${-currentOffset + this.dragDelta}px)`;
  }

  onDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.style.transition = '';

    const threshold = this.getSlideWidth() * 0.25;

    if (this.dragDelta < -threshold) {
      this.next();
    } else if (this.dragDelta > threshold) {
      this.prev();
    } else {
      this.update();
    }

    this.dragDelta = 0;
  }
}

// Initialize all carousels
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.carousel').forEach(el => new Carousel(el));
});
